import React, { Fragment, useState, useEffect } from 'react';
import { ThemeProvider } from 'emotion-theming';
import { BlankPage } from '@packages/fdpq-common';
import { getQueryParamsFromUrl } from '@packages/fdpq-core/utils/url';
import FdpqWidget from './FdpqWidget';
import { getInitialState } from '../utils/VehicleUtil';

const queryParams = getQueryParamsFromUrl();
const shouldRenderWidget = (params) => {
  if (typeof window === 'undefined') {
    return false;
  }
  if (params) {
    return false;
  }
  return true;
};

const FdpqWidgetWrapper = ({ initialData, initialWidgetSize, texts }) => {
  const [state, setState] = useState({
    initialData,
    shouldRenderWidget: shouldRenderWidget(queryParams),
    texts,
  });
  useEffect(() => {
    if (typeof window !== 'undefined' && !shouldRenderWidget(queryParams)) {
      (async () => {
        if (queryParams && queryParams.apikey) {
          const initialState = await getInitialState({ initialData, queryParams, texts });
          setState(initialState);
          window.fdpqWidget = { initialData: initialState.initialData }; // This is for debugging purpose
        }
      })();
    }
  }, []);
  return (
    <Fragment>

      {(state.shouldRenderWidget ? (
        <FdpqWidget initialData={state.initialData} initialWidgetSize={initialWidgetSize}/>
      ) : (
        <ThemeProvider theme={initialData.theme}>
          <BlankPage initialWidgetSize={'LARGE'} hasError={state.hasError} texts={state.texts}/>
        </ThemeProvider>
      ))}
    </Fragment>
  );
};

export default FdpqWidgetWrapper;
